import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '精品一区的内容来源是什么？如何保证内容质量？',
    answer: '精品一区的内容由资深编辑团队从海量信息中精心筛选，涵盖科技前沿、生活美学、人文社科等多个领域。我们坚持严格的审核标准，每篇文章都经过专业的编辑校验和质量评估，确保为您提供高质量、有深度、值得信赖的精选内容。',
  },
  {
    question: '精品一区是否完全免费？有付费内容吗？',
    answer: '精品一区的绝大部分内容都面向所有用户免费开放。我们致力于打造一个开放、共享的精品内容平台，让更多人能够轻松获取优质信息。未来我们可能会推出部分深度研究报告或专属内容服务，但核心内容将始终保持免费。',
  },
  {
    question: '如何在精品一区找到我感兴趣的内容？',
    answer: '您可以通过首页的精选分类快速浏览不同领域的文章，也可以在顶部导航栏中选择具体的分类进行深入阅读。我们的搜索功能支持关键词检索，帮助您精准定位感兴趣的主题内容。此外，每个分类页面都提供了该领域的完整文章列表。',
  },
  {
    question: '精品一区的文章更新频率是怎样的？',
    answer: '我们保持每日更新的节奏，每个工作日至少发布2-3篇经过精心编辑的原创或授权内容。周末和节假日也会不定期更新精选特辑。您可以通过订阅我们的新闻简报，第一时间获取最新发布的优质内容推荐。',
  },
  {
    question: '我可以向精品一区投稿或推荐内容吗？',
    answer: '当然可以！我们非常欢迎优秀的内容创作者加入精品一区的内容生态。您可以通过"联系我们"页面提交您的原创稿件或内容建议。我们的编辑团队会认真审核每一份投稿，优质稿件将有机会在平台上发布并获得推荐位展示。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema, null, 2) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            关于精品一区，您可能想了解的一些信息
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div key={idx} className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
                aria-expanded={openIndex === idx}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 transition-transform duration-300" style={{ transform: openIndex === idx ? 'rotate(45deg)' : 'rotate(0)' }}>
                  <i className="ri-add-line"></i>
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-300"
                style={{
                  maxHeight: openIndex === idx ? '500px' : '0px',
                  opacity: openIndex === idx ? 1 : 0,
                }}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}